import { type Enum } from '@webapp/infrastructure/types/Enum'

// The four field-mapping panels (two per Field Mapping tab).
export const QuickBooksFieldMapModels = {
  PURCHASE_ORDER: 'purchase_order',
  ORDER_ITEMS: 'order_items',
  BILLS: 'bills',
  BILL_EXPENSE_LINES: 'bill_expense_lines',
} as const

export type QuickBooksFieldMapModel = Enum<typeof QuickBooksFieldMapModels>

// API `model` query/body param per panel — purchase_order is pluralized
// server-side; the other three pass through unchanged.
export const QuickBooksFieldMapModelApiParams: Record<
  QuickBooksFieldMapModel,
  string
> = {
  [QuickBooksFieldMapModels.PURCHASE_ORDER]: 'purchase_orders',
  [QuickBooksFieldMapModels.ORDER_ITEMS]: 'order_items',
  [QuickBooksFieldMapModels.BILLS]: 'bills',
  [QuickBooksFieldMapModels.BILL_EXPENSE_LINES]: 'bill_expense_lines',
}
